import React, { useEffect } from 'react';
import NotifyBlueIcon from '../../../../../../images/home-landing-page/notification-blue-icon.png';
import SettingBlueIcon from '../../../../../../images/home-landing-page/setting-blue-icon.png';
import EmptyProfileImage from '../../../../../../images/navbar/empty-profile-image.png'
import { ArrowLeft } from 'lucide-react';

function Index({ activeConversation, setNotification, notification, onBack })
{
    console.log("notification", notification)

    useEffect(() =>
    {
        if (notification)
        {
            const timer = setTimeout(() =>
            {
                setNotification(false);
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [notification, setNotification]); // Re-run the effect if notification changes
    return (


        <div class="chat-header">
            <button className="back-button" onClick={onBack}>
                <ArrowLeft size={24} />
            </button>
            <div class="user-image-name">
                <figure>
                    <img
                        src={(activeConversation?.userProfileUrl == null || activeConversation?.userProfileUrl == "") ? EmptyProfileImage : activeConversation?.userProfileUrl}
                        alt="Profile"
                    /></figure>
                {activeConversation?.userName} ({activeConversation?.businessName})
            </div>
            <div class="chat-actions">
                {/* {notification && <span className='w-2 h-2 bg-red-500 rounded-full mb-6 -mr-4'></span>} */}
                <a href="">
                    <img src={NotifyBlueIcon} alt="Notifications" />
                </a>
                <a href="">
                    <img src={SettingBlueIcon} alt="Settings" />
                </a>
            </div>
        </div>
    )
}

export default Index
